import React from 'react';
import AbstractComponent from '../AbstractComponent';
import ContentPesquisa from '../layout/content/ContentPesquisa';
import TableTypeEnum from '../layout/table/TableTypeEnum';

import AutenticarService from '../../service/AutenticarService';
import NotificacaoService from '../../service/NotificacaoService';

import AcaoEnum from '../../helper/enumerador/AcaoEnum';
import FormCodeEnum from '../../helper/enumerador/FormCodeEnum';

class NotificacaoPesquisa extends AbstractComponent { 
    constructor(props) {
        super(props);        

        this.state = {            
            head: [
                {nome: 'Título', campo: 'title', width: '15%'},                
                {nome: 'Tipo de notificação', campo: 'tipo_notificacao', width: '15%'},                
                {nome: 'Corpo da mensagem', campo: 'body', width: '30%'},
                {nome: 'Data do envio', campo: 'data_envio', width: '15%', type: TableTypeEnum.DATETIME},
                {nome: 'Status', campo: 'status', width: '15%'},
            ],            
            
            callBack: {
                id: 1,

                body: [],

                pagination: [],

                recordCount: 0,

                indice: -1,

                mensagem: {
                    message: '',
                    code: 0
                },

                acao: AcaoEnum.NOTHING
            }            
        }        
    }        
    
    onRemover(uuid, i) {            
        NotificacaoService.delete(uuid).then(() => {            
            let callBack = this.state.callBack;

            callBack.id++;            
            callBack.mensagem = {
                message: 'Push notification excluído com sucesso',
                code: FormCodeEnum.DEFAULT
            };
            callBack.acao = AcaoEnum.REMOVER;
            callBack.indice = i;

            this.setState({ callBack: callBack });
        }).catch(erro => {            
            let callBack = this.state.callBack;

            callBack.id++;            
            callBack.mensagem = this.trataErro(erro);
            callBack.acao = AcaoEnum.ERRO;
            callBack.indice = i;

            this.setState({ callBack: callBack });
        })
    }

    onLoad() {                
        NotificacaoService.listar(
            AutenticarService.getIdEmpresa()
        ).then(resposta => {            
            let callBack = this.state.callBack;

            callBack.id++;
            callBack.body = resposta.data;
            callBack.mensagem = {
                message: '',
                code: 0
            };
            callBack.acao = AcaoEnum.LOAD;            
            callBack.indice = -1;

            this.setState({ callBack: callBack });            
        }).catch(erro => {
            let callBack = this.state.callBack;
            
            callBack.mensagem = this.trataErro(erro);
            callBack.indice = -1;
            callBack.acao = AcaoEnum.ERRO;

            this.setState({ callBack: callBack });
        })
    }

    render() {
        return (            
            <ContentPesquisa 
                title="Lista de Notificações"
                history=""
                                             
                modalErroMsg={this.state.modalErroMsg}

                head={this.state.head}                     
                
                cadastro={true}
                editar={true}
                link={'notificacao'}  
                preload={this.props.preload}                 
                                    
                onLoad={() => this.onLoad()}
                onRemover={(uuid, i) => this.onRemover(uuid, i)}
                callBack={this.state.callBack}     
                
                route={(route) => this.props.route(route)}    
            />
        )
    }
}

export default NotificacaoPesquisa;